import { loadQuotationRelated } from '@/api/price/quotation'
import { DataSyncRefNoBase } from '@/class/model/DataSyncRefNoBase'

export class Quotation extends DataSyncRefNoBase {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'Quotation'
  }

  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get departmentId() {
    return this._data.departmentId
  }
  set departmentId(departmentId) {
    this._data.departmentId = departmentId || 0
  }
  get type() {
    return this._data.type
  }
  set type(type) {
    this._data.type = type || 0
  }
  get quotationNo() {
    return this._data.quotationNo
  }
  set quotationNo(quotationNo) {
    this._data.quotationNo = quotationNo
  }
  get beginDate() {
    return this._data.beginDate
  }
  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }
  get endDate() {
    return this._data.endDate
  }
  set endDate(endDate) {
    this._data.endDate = endDate
  }
  get clientId() {
    return this._data.clientId
  }
  set clientId(clientId) {
    this._data.clientId = clientId || 0
  }
  get receiptPlace() {
    return this._data.receiptPlace
  }
  set receiptPlace(receiptPlace) {
    this._data.receiptPlace = receiptPlace
  }
  get deliveryPlace() {
    return this._data.deliveryPlace
  }
  set deliveryPlace(deliveryPlace) {
    this._data.deliveryPlace = deliveryPlace
  }
  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }
  get goodsName() {
    return this._data.goodsName
  }
  set goodsName(goodsName) {
    this._data.goodsName = goodsName
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get grossWeight() {
    return this._data.grossWeight
  }
  set grossWeight(grossWeight) {
    this._data.grossWeight = grossWeight || 0.0
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage || 0.0
  }
  get size() {
    return this._data.size
  }
  set size(size) {
    this._data.size = size
  }
  get chargeWeight() {
    return this._data.chargeWeight
  }
  set chargeWeight(chargeWeight) {
    this._data.chargeWeight = chargeWeight || 0.0
  }
  get freightTerm() {
    return this._data.freightTerm
  }
  set freightTerm(freightTerm) {
    this._data.freightTerm = freightTerm
  }
  get dangerousGoods() {
    return this._data.dangerousGoods
  }
  set dangerousGoods(dangerousGoods) {
    this._data.dangerousGoods = dangerousGoods || false
  }
  get unNo() {
    return this._data.unNo
  }
  set unNo(unNo) {
    this._data.unNo = unNo
  }
  get hazardClass() {
    return this._data.hazardClass
  }
  set hazardClass(hazardClass) {
    this._data.hazardClass = hazardClass
  }
  get email() {
    return this._data.email
  }
  set email(email) {
    this._data.email = email
  }
  get phone() {
    return this._data.phone
  }
  set phone(phone) {
    this._data.phone = phone
  }
  get fax() {
    return this._data.fax
  }
  set fax(fax) {
    this._data.fax = fax
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get receiptRemark() {
    return this._data.receiptRemark
  }
  set receiptRemark(receiptRemark) {
    this._data.receiptRemark = receiptRemark
  }
  get deliveryRemark() {
    return this._data.deliveryRemark
  }
  set deliveryRemark(deliveryRemark) {
    this._data.deliveryRemark = deliveryRemark
  }
  get contact() {
    return this._data.contact
  }
  set contact(contact) {
    this._data.contact = contact
  }
  get num20() {
    return this._data.num20
  }
  set num20(num20) {
    this._data.num20 = num20 || 0.0
  }
  get num40() {
    return this._data.num40
  }
  set num40(num40) {
    this._data.num40 = num40 || 0.0
  }
  get numHc() {
    return this._data.numHc
  }
  set numHc(numHc) {
    this._data.numHc = numHc || 0.0
  }
  get num45() {
    return this._data.num45
  }
  set num45(num45) {
    this._data.num45 = num45 || 0.0
  }
  get bookingAgent() {
    return this._data.bookingAgent
  }
  set bookingAgent(bookingAgent) {
    this._data.bookingAgent = bookingAgent || 0
  }
  // 业务类型(jobType) 0.出口 1.进口
  get jobType() {
    return this._data.jobType
  }
  set jobType(jobType) {
    this._data.jobType = jobType || 0
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get clientTenantId() {
    return this._data.clientTenantId
  }
  set clientTenantId(clientTenantId) {
    this._data.clientTenantId = clientTenantId || 0
  }
  get clientTenantName() {
    return this._data.clientTenantName
  }
  set clientTenantName(clientTenantName) {
    this._data.clientTenantName = clientTenantName
  }
  // 状态：0待确认，1已接受，2已拒绝(status)
  get status() {
    return this._data.status
  }
  set status(status) {
    this._data.status = status || 0
  }
  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }
  get eta() {
    return this._data.eta
  }
  set eta(eta) {
    this._data.eta = eta
  }
  get clientType() {
    return this._data.clientType
  }
  set clientType(clientType) {
    this._data.clientType = clientType || 0
  }
  get priceUuid() {
    return this._data.priceUuid
  }
  set priceUuid(priceUuid) {
    this._data.priceUuid = priceUuid || null
  }

  /* =============扩展属性================= */
  // 报价单与整箱报价价格明细
  get quotationFclDetail() {
    return this._data.quotationFclDetail
  }
  set quotationFclDetail(quotationFclDetail) {
    this._data.quotationFclDetail = quotationFclDetail
  }
  // 报价单与拼箱报价价格明细
  get quotationLclDetail() {
    return this._data.quotationLclDetail
  }
  set quotationLclDetail(quotationLclDetail) {
    this._data.quotationLclDetail = quotationLclDetail
  }
  // 报价单与空运报价价格明细
  get quotationAirDetail() {
    return this._data.quotationAirDetail
  }
  set quotationAirDetail(quotationAirDetail) {
    this._data.quotationAirDetail = quotationAirDetail
  }
  // 报价单与本地费用
  get quotationChargeDetail() {
    return this._data.quotationChargeDetail
  }
  set quotationChargeDetail(quotationChargeDetail) {
    this._data.quotationChargeDetail = quotationChargeDetail
  }
  // 自定义字段1
  get pricingUserDefinedField1() {
    return this._data.pricingUserDefinedField1
  }
  set pricingUserDefinedField1(pricingUserDefinedField1) {
    this._data.pricingUserDefinedField1 = pricingUserDefinedField1
  }
  // 自定义字段2
  get pricingUserDefinedField2() {
    return this._data.pricingUserDefinedField2
  }
  set pricingUserDefinedField2(pricingUserDefinedField2) {
    this._data.pricingUserDefinedField2 = pricingUserDefinedField2
  }
  // 自定义字段3
  get pricingUserDefinedField3() {
    return this._data.pricingUserDefinedField3
  }
  set pricingUserDefinedField3(pricingUserDefinedField3) {
    this._data.pricingUserDefinedField3 = pricingUserDefinedField3
  }
  // 自定义字段4
  get pricingUserDefinedField4() {
    return this._data.pricingUserDefinedField4
  }
  set pricingUserDefinedField4(pricingUserDefinedField4) {
    this._data.pricingUserDefinedField4 = pricingUserDefinedField4
  }

  get status2() {
    return this._data.status2
  }
  set status2(status2) {
    this._data.status2 = status2 || 0
  }
  get solveUserId() {
    return this._data.solveUserId
  }
  set solveUserId(solveUserId) {
    this._data.solveUserId = solveUserId || ''
  }
  get inquiryPriceUuid() {
    return this._data.inquiryPriceUuid
  }
  set inquiryPriceUuid(inquiryPriceUuid) {
    this._data.inquiryPriceUuid = inquiryPriceUuid || ''
  }

  get tempClientId() {
    return this._data.tempClientId
  }
  set tempClientId(tempClientId) {
    this._data.tempClientId = tempClientId || ''
  }

  get num20Nor() {
    return this._data.num20Nor
  }
  set num20Nor(num20Nor) {
    this._data.num20Nor = num20Nor || 0.0
  }

  get num40Nor() {
    return this._data.num40Nor
  }
  set num40Nor(num40Nor) {
    this._data.num40Nor = num40Nor || 0.0
  }

  get serviceTerm() {
    return this._data.serviceTerm
  }

  set serviceTerm(serviceTerm) {
    this._data.serviceTerm = serviceTerm || ''
  }

  get commerceCode() {
    return this._data.commerceCode
  }

  set commerceCode(commerceCode) {
    this._data.commerceCode = commerceCode || ''
  }

  get palletNature() {
    return this._data.palletNature
  }

  set palletNature(palletNature) {
    this._data.palletNature = palletNature || 1
  }

  get cargoReadyTimeType() {
    return this._data.cargoReadyTimeType
  }

  set cargoReadyTimeType(cargoReadyTimeType) {
    this._data.cargoReadyTimeType = cargoReadyTimeType || 'range'
  }

  get cargoReadyTimeRange() {
    return this._data.cargoReadyTimeRange
  }

  set cargoReadyTimeRange(cargoReadyTimeRange) {
    this._data.cargoReadyTimeRange = cargoReadyTimeRange || 2
  }

  get cargoReadyTimeDate() {
    return this._data.cargoReadyTimeDate
  }

  set cargoReadyTimeDate(cargoReadyTimeDate) {
    this._data.cargoReadyTimeDate = cargoReadyTimeDate
  }

  get directTransit() {
    return this._data.directTransit
  }

  set directTransit(directTransit) {
    this._data.directTransit = directTransit || 1
  }

  get transferPortCode() {
    return this._data.transferPortCode
  }

  set transferPortCode(transferPortCode) {
    this._data.transferPortCode = transferPortCode || ''
  }

  get carrierId() {
    return this._data.carrierId
  }

  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }

  get cargoType() {
    return this._data.cargoType
  }

  set cargoType(cargoType) {
    this._data.cargoType = cargoType || ''
  }

  get dangerousGoodsLevel() {
    return this._data.dangerousGoodsLevel
  }

  set dangerousGoodsLevel(dangerousGoodsLevel) {
    this._data.dangerousGoodsLevel = dangerousGoodsLevel || 0
  }

  get length() {
    return this._data.length
  }

  set length(length) {
    this._data.length = length || 0.0
  }

  get width() {
    return this._data.width
  }

  set width(width) {
    this._data.width = width || 0.0
  }

  get height() {
    return this._data.height
  }

  set height(height) {
    this._data.height = height || 0.0
  }

  get temperature() {
    return this._data.temperature
  }

  set temperature(temperature) {
    this._data.temperature = temperature || 0.0
  }

  get ventilationQuantity() {
    return this._data.ventilationQuantity
  }

  set ventilationQuantity(ventilationQuantity) {
    this._data.ventilationQuantity = ventilationQuantity || 0.0
  }

  get quotationMethod() {
    return this._data.quotationMethod
  }

  set quotationMethod(quotationMethod) {
    this._data.quotationMethod = quotationMethod || 0
  }

  get country() {
    return this._data.country
  }

  set country(country) {
    this._data.country = country || 'CN'
  }

  get province() {
    return this._data.province
  }

  set province(province) {
    this._data.province = province || ''
  }

  get city() {
    return this._data.city
  }

  set city(city) {
    this._data.city = city || ''
  }

  get districts() {
    return this._data.districts
  }

  set districts(districts) {
    this._data.districts = districts || ''
  }

  get townUuid() {
    return this._data.townUuid
  }

  set townUuid(townUuid) {
    this._data.townUuid = townUuid || ''
  }

  get transportMode() {
    return this._data.transportMode
  }

  set transportMode(transportMode) {
    this._data.transportMode = transportMode || 1
  }

  get branchLine() {
    return this._data.branchLine
  }

  set branchLine(branchLine) {
    this._data.branchLine = branchLine || 0
  }

  get deliveryAddressType() {
    return this._data.deliveryAddressType
  }

  set deliveryAddressType(deliveryAddressType) {
    this._data.deliveryAddressType = deliveryAddressType || 1
  }

  get postalCode() {
    return this._data.postalCode
  }

  set postalCode(postalCode) {
    this._data.postalCode = postalCode || ''
  }

  get address() {
    return this._data.address
  }

  set address(address) {
    this._data.address = address || ''
  }

  get warehouseCode() {
    return this._data.warehouseCode
  }

  set warehouseCode(warehouseCode) {
    this._data.warehouseCode = warehouseCode
  }

  get detailAddress() {
    return this._data.detailAddress
  }

  set detailAddress(detailAddress) {
    this._data.detailAddress = detailAddress || ''
  }

  get prePortLastMileDetails() {
    return this._data.prePortLastMileDetails
  }
  set prePortLastMileDetails(prePortLastMileDetails) {
    this._data.prePortLastMileDetails = prePortLastMileDetails || []
  }

  get delPrePortLastMileDetailUuids() {
    return this._data.delPrePortLastMileDetailUuids
  }
  set delPrePortLastMileDetailUuids(delPrePortLastMileDetailUuids) {
    this._data.delPrePortLastMileDetailUuids = delPrePortLastMileDetailUuids || []
  }

  get delPrePortLastMileChargingItemUuids() {
    return this._data.delPrePortLastMileChargingItemUuids
  }
  set delPrePortLastMileChargingItemUuids(delPrePortLastMileChargingItemUuids) {
    this._data.delPrePortLastMileChargingItemUuids = delPrePortLastMileChargingItemUuids || []
  }

  // 加载Quotation的关联实体信息
  async loadQuotationRelated(params) {
    params.quotationUuid = params.quotationUuid || this._data.uuid
    if (!params.quotationUuid) return
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'quotationUuid') {
        continue
      }
      if (key !== 'quotation' && params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadQuotationRelated(params).then(res => {
      const items = res.data
      if (items.quotation) {
        for (const key in items.quotation) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.quotation[key]
        }
      }
      for (const key in items) {
        if (key === 'quotation') continue
        this._data[key] = items[key] || null
      }
    })
  }
}
